import React, { useState } from 'react';
import { postPublicRequest } from "../api/auth";
import API_ROUTES from "./config/apiConfig";

export default function CustomDesign() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    material: "",
    timeline: "",
    message: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const enquiryMessage = `
Company / Studio:
${formData.company}

Material Focus:
${formData.material || "Not specified"}

Project Timeline:
${formData.timeline || "Flexible"}

Custom Requirement:
${formData.message}
      `;

      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: enquiryMessage
      };

      const res = await postPublicRequest(
        API_ROUTES.CREATE_ENQUIRY,
        payload
      );

      if (res.success) {
        setSubmitted(true);
        setFormData({
          name: "",
          company: "",
          email: "",
          phone: "",
          material: "",
          timeline: "",
          message: ""
        });
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="custom-studio-universe">
      {/* Ambient background glows */}
      <div className="studio-ambient-glow-1"></div>
      <div className="studio-ambient-glow-2"></div>

      {/* Hero Section */}
      <section className="studio-hero text-center">
        <div className="container studio-slide-up">
          <span className="premium-eyebrow">
            <span className="eyebrow-symbol">✧</span> BESPOKE ARCHITECTURAL STUDIO
          </span>

          <h1 className="studio-title">
            Tailored Illumination
            <span className="gold-text-gradient">
              Bespoke Fabrication & Custom Design
            </span>
          </h1>

          <div className="accent-glow-bar"></div>

          <p className="studio-subtitle">
            From hand-etched brass fixtures to custom dimension statements for luxury hotels, fine residences, and boutique commercial venues.
          </p>
        </div>
      </section>

      {/* Form Container */}
      <section className="container brief-form-container">
        <div className="form-glass-card studio-fade-in">
          {submitted ? (
            <div className="studio-success-pane text-center">
              <div className="success-icon-badge">✓</div>
              <h2>Design Brief Registered</h2>
              <p>
                Your bespoke requirements have been forwarded to our engineering team. We will contact you within 24 hours with feasibility insights and a preliminary estimate.
              </p>
              <button
                type="button"
                className="btn-studio-submit reset-btn"
                onClick={() => setSubmitted(false)}
              >
                SUBMIT ANOTHER BRIEF
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="studio-brief-form">
              <div className="form-header-group">
                <h2 className="form-heading">Initiate Fabrication Blueprint</h2>
                <p className="form-subheading">
                  Share your specifications below and our bespoke desk will tailor an architectural solution.
                </p>
              </div>

              <div className="form-row-split">
                <div className="input-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="e.g. Liam Sterling"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Company / Studio Firm</label>
                  <input
                    type="text"
                    name="company"
                    placeholder="e.g. Atelier Studio Design"
                    value={formData.company}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row-split">
                <div className="input-group">
                  <label>Work Email *</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="name@studio.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Contact Phone / WhatsApp *</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 98765 43210"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row-split">
                <div className="input-group">
                  <label>Target Material Focus</label>
                  <input
                    type="text"
                    name="material"
                    placeholder="e.g. Antiqued Brass, Hand-Blown Glass, Alabaster"
                    value={formData.material}
                    onChange={handleChange}
                  />
                </div>

                <div className="input-group">
                  <label>Project Timeline / Target Delivery</label>
                  <input
                    type="text"
                    name="timeline"
                    placeholder="e.g. Q3 2026 / 4-6 Weeks"
                    value={formData.timeline}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Outline Custom Sizing or Blueprint Requirements *</label>
                <textarea
                  rows="4"
                  name="message"
                  placeholder="Detail dimensions, finishing expectations, quantity estimates, and any architectural scope details..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn-studio-submit">
                SUBMIT BLUEPRINT BRIEF TO MANUFACTURE
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}